import React from 'react';
// import '../../_assets/css/file.css';
import { Form } from "react-bootstrap";
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { ROLE, TOKEN } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import { Customers } from './customer_view';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
// import CreateAddress from '../Address/createCustomerAddress';


class AgentDetails extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
        };
        this.state = {
            isLoading: false,
            isShowError: false,
            statusMessage: '',
            showError: false,
        }
    }
    componentDidMount() {
        this.getData();
    }
    getData = (queryString = "") => {
        let formData = {
            "session_id": TOKEN,

        }
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "get_agent_details"

        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((agentResponse) => {


            this.setState({
                agent_name: agentResponse.data.agent.name,
                agent_msisdn: agentResponse.data.agent.msisdn,
                agent_status: agentResponse.data.agent.status,
                agent_email: agentResponse.data.agent.email,
                account_commission: agentResponse.data.account.commission,
                account_float: agentResponse.data.account.float,
                account_cash: agentResponse.data.account.cash,
                bankname: agentResponse.data.bank.name,
                bank_acc: agentResponse.data.bank.account_no

            }, function () {
                localStorage.setItem("AGENTNAME", agentResponse.data.agent.name)
                localStorage.setItem("AGENTPHONE", this.state.agent_msisdn)
                localStorage.setItem("AGENTEMAIL", this.state.agent_email)
            })
            console.log("agent", this.state.agent_email)
            if (this.state.bank_acc === null) {
                alert("It seem that you dont have your bank details. Please add them")
            }

        })).catch(error => {
            console.log('bayoo', error.response)

        })
    }
    render() {
        const { showComponent, agent_name, agent_msisdn, agent_email, agent_status, account_cash, account_commission, account_float, bank_acc, bankname } = this.state;
        const { hideComponent } = this.state;
        const { moreinfo } = this.state;


        // alert(ROLE)

        return (
            <div>
                {/* {showComponent && (
                    <div>
                        {this.state.showComponent ?
                            <Customers /> : null
                        }
                    </div>
                )}
                {moreinfo && (
                    <div>
                        {this.state.moreinfo ?
                            <CreateAddress /> : null
                        }
                    </div>
                )} */}

                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4><b>Agent Details</b></h4><br />
                                        </div>
                                        <div className="col-md-6">
                                            <Link to="/account/modify">
                                                <Button className="float-right" color="primary
                                                    " onClick={this._onButtonClick} outline>Modify Details
                                                </Button>
                                            </Link>
                                        </div>

                                    </div>
                                    <div className="col-md-10 offset-1"><br /><br />

                                        <div className="row">
                                            <div className="col-md-6">
                                                <h4><b>Profile</b></h4><br />
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label"><b>Name : </b> {agent_name}</label>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label"><b>Phone# : </b> {agent_msisdn}</label>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label"><b>Email :</b> {agent_email}</label>

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label"><b>Status : </b> {agent_status}</label>
                                                    </div>

                                                </div>


                                                <div className="form-group"><br />
                                                   <h5><b>Bank Details</b></h5><br />

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label className="form-label"><b>Bank Name : </b> {bankname === null ? "___" : bankname}</label><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">

                                                            <label className="form-label"><b>Account# :</b> {bank_acc === null ? "___" : bank_acc}</label><br />
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                            <div className="col-md-6 " >

                                                <h4><b>Account</b></h4><br />
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label"><b>Account Commission : </b> {account_commission}</label><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">

                                                        <label className="form-label"><b>Account Float : </b> {account_float}</label><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className="form-label"><b>Account Cash :</b> {account_cash}</label>
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>


                                    </div>



                                </CardBody>
                            </Card>
                        </Col >
                    </>
                )
                }
            </div>
        )
    }
}
export default withTranslation('common')(AgentDetails);
